module.exports = __webpack_public_path__ + "static/media/Undo-Arrow.44a0826c.svg";